import { render, staticRenderFns } from "./dealersignorderlogs.vue?vue&type=template&id=d35492ee&scoped=true"
import script from "./dealersignorderlogs.vue?vue&type=script&lang=js"
export * from "./dealersignorderlogs.vue?vue&type=script&lang=js"
import style0 from "./dealersignorderlogs.vue?vue&type=style&index=0&id=d35492ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35492ee",
  null
  
)

export default component.exports